// frontend/src/App.js
import React, { useState, useEffect, useCallback, useRef } from "react";
import ReactMarkdown from "react-markdown";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import Login from "./Login";
import Sidebar from "./Sidebar";
import PortfolioPage from "./pages/PortfolioPage";
import WatchlistPage from "./pages/WatchlistPage";
import SearchPage from "./pages/SearchPage";

// import BotStyleSelector from "./BotStyleSelector";
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useNavigate, useLocation, useParams } from "react-router-dom";
import UserRegistrationForm from './components/admin/UserRegistrationForm';
import AccuracyPanel from "./components/AccuracyPanel";
import BottomNav from "./components/nav/BottomNav";
import StocksPanel from "./components/StocksPanel";
import StockDetailPage from "./pages/StockDetailPage";
import TickerSearchBox from "./components/TickerSearchBox";
import ActivationCodeModal from "./components/ActivationCodeModal";
import UserProfileModal from "./components/UserProfileModal";

import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";

import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

import { AuthProvider, useAuth } from './AuthProvider';
import ClusterSelector from "./ClusterSelector";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

function RequireLogin({ children }) {
  const { isLoggedIn } = useAuth();

  if (!isLoggedIn) {
    return <Login />;
  }

  return children;
}

function MainApplication() {
	const {
			token,
			setToken,
			isLoggedIn,
			setIsLoggedIn,
			userEmail,
			userName,
			userRole,
			handleLogout
	} = useAuth();

	const [question, setQuestion] = useState("");
	const [loading, setLoading] = useState(false);
	const [uploading, setUploading] = useState(false);
	const [showProfileMenu, setShowProfileMenu] = useState(false);
	const [sources, setSources] = useState([]);

	const [showActivationCodeModal, setShowActivationCodeModal] = useState(false);

	const [showUserProfileModal, setShowUserProfileModal] = useState(false);

	const [messages, setMessages] = useState([]);
	
	const navigate = useNavigate();
	const { cid } = useParams();

	const nav = useNavigate();
	const [tickerSearch, setTickerSearch] = useState("");
	
	const goTicker = () => {
	  const code = (tickerSearch || "").trim().toUpperCase();
	  if (!code) return;
	  nav(`/stocks/${code}`);
	};	

    // --- State location untuk BottomNav ---
	const location = useLocation();
	const path = location.pathname;
	const isStockDetail = path.startsWith("/stocks/");

	const isStockpicks = path.startsWith("/stockpicks");
	const isWatchlist  = path.startsWith("/watchlist");
	const isSearch     = path.startsWith("/search");
	const isAsk        = path.startsWith("/ask");
	const isPortfolio  = path.startsWith("/portfolio");

	const [showChatListMobile, setShowChatListMobile] = useState(true);
	const [menuOpenIdMobile, setMenuOpenIdMobile] = useState(null);
	const [askMode, setAskMode] = useState("list"); // "list" | "chat"
	const askIntentRef = useRef(null); // "list" | "chat" | null

	const openAskList = () => {
		askIntentRef.current = "list";
		navigate("/ask");
	};

	const openAskChat = () => {
		askIntentRef.current = "chat";
		navigate("/ask");
	};
    
	const isUUID = (s) =>
		/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(String(s || "").trim());

	// --- State untuk PDF Viewer ---
	const [currentPdfUrl, setCurrentPdfUrl] = useState(null);
	const [numPages, setNumPages] = useState(null);
	const [pageNumber, setPageNumber] = useState(1);
	const [pdfLoading, setPdfLoading] = useState(false);
	const pdfContainerRef = useRef(null);
	const [showFilesPanel, setShowFilesPanel] = useState(false);
	const [showPdfViewer, setShowPdfViewer] = useState(false);
	// const [selectedFiles, setSelectedFiles] = useState({});
	const [selected, setSelected] = useState(new Set());
	// --- End State baru ---

	// --- State untuk image viewer
	const [currentImageUrl, setCurrentImageUrl] = useState(null);
	const [showImageViewer, setShowImageViewer] = useState(false);
	const [imageLoading, setImageLoading] = useState(false);
	// const [sidebarOpen, setSidebarOpen] = useState(false);
	// --- end state

	// --- Header apps
	const [category, setCategory] = useState("bandar_v1");  // engine
	const [groupBy, setGroupBy] = useState("all");         // none|subindustry|konglo

	const categories = [
		{ value: "bandar_v1", label: "Bandarmology v1" },
		{ value: "bandar_v2", label: "Bandarmology v2" },
		{ value: "value", label: "Value Investing" }, 
	];
	// ---

	// refresh tidak berubah layout 
	const [sidebarOpen, setSidebarOpen] = useState(() => {
	  const v = localStorage.getItem("ui:sidebarOpen");
	  return v === null ? true : v === "true";
	});
	
	const [layout, setLayout] = useState(() => {
			const v = localStorage.getItem("ui:layout"); // "60,40" misalnya
			return v ? v.split(",").map(Number) : null;
	});

	const handleLayout = (sizes) => {
	// sizes = array persen [left, right]
	localStorage.setItem("ui:layout", sizes.join(","));
	setLayout(sizes);
	};
	// end

	// mobile view
	const handleOpenChatFromSidebar = (chatPublicId) => {
	  openChat(chatPublicId);
	  if (window.innerWidth < 768) {
	    setSidebarOpen(false);
	    setMobileView && setMobileView("chat"); 
	  }
	};

	const [rightPanelMode, setRightPanelMode] = useState(() => {
			// '', 'stocks', 'pdf', 'image'
			return localStorage.getItem("ui:rightPanelMode") || null;
	});

	const openPdf = (url) => {
		setCurrentPdfUrl(url);
		setRightPanelMode("pdf");
	};
	
	const openImage = (url) => {
		setCurrentImageUrl(url);
		setRightPanelMode("image");
	};
			
	const closeRightPanel = () => {
		setRightPanelMode(null);
		setCurrentPdfUrl(null);
		setCurrentImageUrl(null);
		setPageNumber(1);
	};
	// end state
    
	const [files, setFiles] = useState([]);
	const MAX_ANON_FILES = 3;
	//    const MAX_ANON_CHATS = 10;

	const [showLoginPrompt, setShowLoginPrompt] = useState(false);
	const [showUserRegistrationModal, setShowUserRegistrationModal] = useState(false);

	const messagesEndRef = useRef(null);

	const [activeCluster, setActiveCluster] = useState(null);

	const [chatList, setChatList] = useState([]);

	const [activeChatPublicId, setActiveChatPublicId] = useState(null);

	const triggerLoginPrompt = () => {
			if (!isLoggedIn) {
					setShowLoginPrompt(true);
			}
	};

	const getAuthHeaders = () => {
			const headers = {};
			if (isLoggedIn) {
					headers["Authorization"] = `Bearer ${token}`;
			} else {
					headers["X-Anon-Token"] = token;
			}
			return headers;
	};

	// utils
	const PERSONAL_CLUSTER_ID = 4;
	const setCluster = (id) => {
	  setActiveCluster(id);
	  localStorage.setItem("activeClusterId", String(id));  
	};
	
	const logout = () => {
			handleLogout();
			setCurrentPdfUrl(null);
			setMessages([]);
			setShowFilesPanel(false);
			setShowPdfViewer(false);
			setShowLoginPrompt(false);
			alert("You have been logged out. Your new session is anonymous.");
	};

	// saat memilih cluster (dropdown/selector)
	const handleSelectCluster = (opt) => {
		const id = typeof opt === "object" ? opt?.id : opt;
		const name = typeof opt === "object" ? opt?.name : String(opt ?? "");
		setActiveCluster(id ?? null);
		localStorage.setItem("activeClusterId", String(id ?? ""));
		localStorage.setItem("activeClusterName", name ?? "");
	localStorage.removeItem("activeChatPublicId");
	};

	// saat toggle checkbox
	const toggle = (id) => {
			setSelected(prev => {
					const s = new Set(prev);
					s.has(id) ? s.delete(id) : s.add(id);
					return s;
			});
	};

	const [systemMessage, setSystemMessage] = useState(`

	You are VistaBot, an AI assistant for Saham Vista,
	specialized in Indonesian stock market (BEI).

	Your role is to provide objective, data-driven,
	and risk-aware stock analysis.

	CORE BEHAVIOR:
	- Use Bahasa Indonesia (santai-profesional).
	- Be clear, structured when needed, and concise.
	- Avoid hype, guarantees, and emotional language.
	- Never guarantee profit.
	- Focus on probability, confirmation, and risk awareness.

	ANALYSIS GUIDELINES:
	- Use available data such as:
		price trend, MA structure, volume behavior,
		foreign net flow, and broker summary.
	- If data conflicts, explain it clearly.
	- If data is incomplete, downgrade confidence.
	- Do not force a signal when evidence is weak.

	LANGUAGE RULES:
	Allowed:
	- indikasi, peluang, konfirmasi, risiko, invalidasi
	- flow mendukung / melemah
	- sinyal spekulatif

	Forbidden:
	- pasti naik, auto cuan
	- gas, serok, to the moon
	- ajakan all-in atau FOMO
	- insulting broker or emiten

	Your job is not to predict,
	but to help users think more clearly and manage risk better.

	`);

	const sendingRef = useRef(false);

	const autoRenameChatByPublicId = async (chatPublicId, botReply) => {
	  const cid = String(chatPublicId || "").trim();
	  if (!cid || !botReply) return;
	
	  try {
	    const res = await fetch("/api/chats/rename-title", {
	      method: "POST",
	      headers: { "Content-Type": "application/json", ...getAuthHeaders() },
	      body: JSON.stringify({
	        chat_public_id: cid,
	        answer_text: botReply,
	      }),
	    });
	
	    const js = await res.json();
	    if (!res.ok) throw new Error(js?.detail || "Gagal auto rename");
	
	    // ✅ update state chatList biar langsung berubah tanpa refetch
	    setChatList((prev) =>
	      (prev || []).map((c) =>
	        String(c.public_id || "").trim() === cid
	          ? { ...c, title: js.new_title || c.title }
	          : c
	      )
	    );
	
	    // optional: kalau kamu tetap mau refresh list dari server:
	    // fetchChats(activeCluster);
	  } catch (err) {
	    console.error("❌ Auto Rename Failed:", err);
	  }
	};
	
	const ask = async (overrideText) => {
	  let data;
	
	  if (sendingRef.current) return;
	
	  const raw = typeof overrideText === "string" ? overrideText : question;
	  const q = (raw || "").trim();
	  if (!q) return;
	
	  if (!activeCluster) {
	    setMessages((p) => [...p, { role: "bot", text: "❗Pilih cluster terlebih dahulu." }]);
	    return;
	  }
	
	  // ✅ ambil public_id aktif
	  const cid =
	    String(activeChatPublicId || "").trim() ||
	    String(localStorage.getItem("activeChatPublicId") || "").trim();
	
	  if (!cid) {
	    console.error("❌ Tidak ada activeChatPublicId. Pastikan sudah klik New Chat atau pilih chat.");
	    setMessages((p) => [...p, { role: "bot", text: "❗Tidak ada riwayat chat aktif." }]);
	    return;
	  }
	
	  sendingRef.current = true;
	  setMessages((p) => [...p, { role: "user", text: q }]);
	
	  if (typeof overrideText !== "string") setQuestion("");
	  setLoading(true);
	
	  try {
	    const payload = {
	      cluster_id: activeCluster,
	      chat_public_id: cid,
	      question: q,
	      system_message: systemMessage,
	      selected_upload_ids: Array.from(selected || []).map(Number),
	    };
	
	    console.log("[ask] payload ->", payload);
	
	    const res = await fetch("/api/query", {
	      method: "POST",
	      headers: { "Content-Type": "application/json", ...getAuthHeaders() },
	      body: JSON.stringify(payload),
	    });
	
	    data = await res.json();
	
	    // ✅ sync public_id dari backend
	    const returnedPid = String(data?.chat_public_id || "").trim();
	    if (returnedPid) {
	      setActiveChatPublicId(returnedPid);
	      localStorage.setItem("activeChatPublicId", returnedPid);
	    }
	
	    setMessages((p) => [
	      ...p,
	      { role: "bot", text: (data?.answer || "").trim() || "⚠️ Balasan kosong." },
	    ]);
	
	    // ✅ Auto rename (pakai public_id)
		const pidForThis = String(data?.chat_public_id || cid || "").trim();
		
		const thisChat = (chatList || []).find(
		  (c) => String(c.public_id || "").trim() === pidForThis
		);
		
		const titleNow = String(thisChat?.title || "").trim().toLowerCase();
		const isNewTitle = titleNow === "new chat" || titleNow === "new chats";
		
		if (isNewTitle && data?.answer) {
		  autoRenameChatByPublicId(pidForThis, data.answer);
		}
	  } catch (e) {
	    console.error("ask error:", e);
	    setMessages((p) => [...p, { role: "bot", text: "❌ Error while processing your question." }]);
	  } finally {
	    setLoading(false);
	    sendingRef.current = false;
	  }
	};


	// Ambil ID cluster dengan aman (object atau number)
	const getClusterId = (v) => (typeof v === "object" ? v?.id : v) ?? null;

	const createNewChat = async () => {
		if (!activeCluster) {
			setMessages((p) => [...p, { role: "bot", text: "❗Pilih cluster terlebih dahulu." }]);
			return null;
		}

		try {
			const res = await fetch(`/api/chats`, {
				method: "POST",
				headers: { "Content-Type": "application/json", ...getAuthHeaders() },
				body: JSON.stringify({ cluster_id: activeCluster, title: "New chat" }),
			});
			if (!res.ok) throw new Error(`createNewChat ${res.status}`);

			const json = await res.json();

			// ✅ ambil PUBLIC ID, bukan chat_id
			const newPublicId = String(json.public_id || "").trim();
			if (!newPublicId) throw new Error("createNewChat: public_id missing");

			setActiveChatPublicId(newPublicId);
			setMessages([]);

			// ✅ simpan public id yang benar
			localStorage.setItem("activeChatPublicId", newPublicId);

			// refresh list
			const list = await fetch(`/api/chats?cluster_id=${activeCluster}`, {
				headers: getAuthHeaders(),
			}).then((r) => r.json());
			setChatList(list.items || []);

			return newPublicId;
		} catch (e) {
			console.error("createNewChat error:", e);
			return null;
		}
	};

	
	// Buka chat yang ada
	const openChat = async (chatPublicId) => {
	  try {
	    const cid = String(chatPublicId || "").trim();
	    if (!cid) return;
	
	    const res = await fetch(`/api/chats/c/${encodeURIComponent(cid)}/prompts`, {
	      headers: getAuthHeaders(),
	    });
	    if (!res.ok) throw new Error(`openChat ${res.status}`);
	
	    const payload = await res.json();
	    const items = Array.isArray(payload?.items)
	      ? payload.items
	      : Array.isArray(payload)
	      ? payload
	      : [];
	
	    const normalized = items
	      .map((it) => {
	        const roleSrc = String(it.role || "user").toLowerCase();
	        const role =
	          roleSrc === "assistant"
	            ? "bot"
	            : roleSrc === "system"
	            ? "system"
	            : roleSrc === "tool"
	            ? "tool"
	            : "user";
	
	        const text =
	          (typeof it.content === "string" && it.content) ||
	          (typeof it.text === "string" && it.text) ||
	          "";
	
	        const rawCreatedAt = it.created_at
	          ? typeof it.created_at === "number"
	            ? it.created_at
	            : Date.parse(it.created_at)
	          : undefined;
	
	        const createdAt = Number.isFinite(rawCreatedAt) ? rawCreatedAt : undefined;
	
	        return {
	          role,
	          text,
	          idClient:
	            it.id_client ||
	            it.uuid ||
	            (crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random()}`),
	          createdAt,
	        };
	      })
	      .filter((m) => m.text)
	      .sort((a, b) => (a.createdAt ?? 0) - (b.createdAt ?? 0));
	
	    setMessages(normalized);
	
	    // ✅ public id saja
	    setActiveChatPublicId(cid);
	    localStorage.setItem("activeChatPublicId", cid);
	
	  } catch (e) {
	    console.error("openChat error:", e);
	    setMessages([{ role: "bot", text: "❌ Gagal memuat riwayat chat." }]);
	  }
	};


	// Handler khusus untuk Ask AI dari Stocks
	const handleAskAiFromStocks = async (prompt, kodeSaham) => {
	  if (!activeCluster) {
	    setMessages((p) => [...p, { role: "bot", text: "❗Pilih cluster terlebih dahulu sebelum tanya AI dari panel saham." }]);
	    return;
	  }
	
	  try {
	    let isNewChat = false;
	
	    // pakai state dulu kalau ada
	    let chatPublicId = activeChatPublicId || localStorage.getItem("activeChatPublicId");
	
	    if (!isUUID(chatPublicId)) {
	      const newPublicId = await createNewChat();
	      if (!newPublicId) return;
	      chatPublicId = String(newPublicId).trim();
	      localStorage.setItem("activeChatPublicId", chatPublicId);
	      isNewChat = true;
	    }
	
	    setActiveChatPublicId(chatPublicId);
	
	    if (isNewChat) {
	      const newTitle = `Ask AI: ${kodeSaham}`;
	
	      setChatList((prev) => {
	        const exists = prev.some((c) => c.public_id === chatPublicId);
	        if (exists) {
	          return prev.map((c) => (c.public_id === chatPublicId ? { ...c, title: newTitle } : c));
	        }
	        return [{ public_id: chatPublicId, title: newTitle }, ...prev];
	      });
	
	      try {
	        await fetch(`/api/chats/c/${encodeURIComponent(chatPublicId)}/rename`, {
	          method: "POST",
	          headers: {
	            "Content-Type": "application/json",
	            ...(token ? { Authorization: `Bearer ${token}` } : {}),
	          },
	          body: JSON.stringify({ title: newTitle }),
	        });
	      } catch (e) {
	        console.warn("Gagal rename chat di server:", e);
	      }
	    }
	
	    if (typeof window !== "undefined" && window.innerWidth < 768) {
	      setMobileView("chat");
	      setSidebarOpen(false);
	    }
	
	    navigate("/ask");
	    await ask(prompt);
	  } catch (err) {
	    console.error("[Ask AI from Stocks] error:", err);
	    setMessages((p) => [...p, { role: "bot", text: "⚠️ Terjadi error saat memproses pertanyaan dari panel saham. Coba lagi." }]);
	  }
	};


	// Rename Chat — Bisa manual (prompt) atau auto (dari parameter)
	const handleRenameChat = async (chatPublicId, newTitle = null) => {
		console.log("🔧 Rename triggered for chat:", chatPublicId);

		if (!newTitle) {
			newTitle = prompt("Ganti nama chat:");
			if (!newTitle) return;
		}

		try {
			const cid = String(chatPublicId || "").trim();
			const res = await fetch(`/api/chats/c/${encodeURIComponent(cid)}/rename`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					...getAuthHeaders(),
				},
				body: JSON.stringify({ title: newTitle }),
			});

			if (!res.ok) throw new Error("Gagal mengganti nama chat");
			fetchChats(activeCluster);
		} catch (err) {
			console.error("Rename error:", err);
			alert("❌ Gagal mengganti nama chat.");
		}
	};
	
	// Delete Chat
	const handleDeleteChat = async (chatPublicId) => {
		console.log("🔧 Delete triggered for chat:", chatPublicId);
		const confirmDelete = window.confirm("Yakin ingin menghapus chat ini?");
		if (!confirmDelete) return;

		try {
			const cid = String(chatPublicId || "").trim();
			const res = await fetch(`/api/chats/c/${encodeURIComponent(cid)}`, {
				method: "DELETE",
				headers: getAuthHeaders(),
			});

			if (!res.ok) throw new Error("Gagal menghapus chat");

			// Clear kalau yg aktif dihapus
			const active = localStorage.getItem("activeChatPublicId");
			if (active && active === cid) {
				setActiveChatPublicId(null);
				setMessages([]);
				localStorage.removeItem("activeChatPublicId");
			}

			fetchChats(activeCluster);
		} catch (err) {
			console.error("Delete error:", err);
			alert("❌ Gagal menghapus chat.");
		}
	};

	// Auto Rename Chat berdasarkan jawaban Bot (max 4 kata)
	const autoRenameChat = async (chatPublicId, botReply) => {
		if (!botReply || !chatPublicId) return;

		try {
			console.log("🚀 Auto rename trigger:", { chatPublicId, botReply });

			const res = await fetch("/api/chats/rename-title", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					...getAuthHeaders(),
				},
				body: JSON.stringify({
					chat_public_id: String(chatPublicId).trim(),
					answer_text: botReply,
				}),
			});

			const result = await res.json();
			if (!res.ok) throw new Error(result.detail || "Gagal auto rename");

			console.log("✅ Auto Rename Success:", result.new_title);
			fetchChats?.(activeCluster);
		} catch (err) {
			console.error("❌ Auto Rename Failed:", err);
		}
	};

	const handleFileUpload = async (e) => {
	  const files = e.target.files;
	  if (!files || files.length === 0) return;
	
	  const clusterId = getClusterId(activeCluster);
	  if (!clusterId) {
	    alert("❗ Please select a cluster before uploading.");
	    e.target.value = null;
	    return;
	  }
	
	  if (!isLoggedIn && files.length >= MAX_ANON_FILES) {
	    alert(`Anonymous users can upload a maximum of ${MAX_ANON_FILES} files.`);
	    triggerLoginPrompt();
	    e.target.value = null;
	    return;
	  }
	
	  const maxFileSizeMB = 50;
	  const maxFileSizeBytes = maxFileSizeMB * 1024 * 1024;
	
	  // 🚀 Loop semua file dan upload satu per satu
	  for (const file of Array.from(files)) {
	    if (file.size > maxFileSizeBytes) {
	      alert(`❌ ${file.name} too large. Maximum ${maxFileSizeMB}MB.`);
	      continue;
	    }
	
	    const formData = new FormData();
	    formData.append("file", file, file.name);
	    formData.append("cluster_id", String(clusterId));
	
	    setUploading(true);
	    try {
	      const res = await fetch("/api/upload-file", {
	        method: "POST",
	        headers: {
	          Authorization: `Bearer ${token}`,
	        },
	        body: formData,
	      });
	
	      if (!res.ok) {
	        const errorData = await res.json().catch(() => ({}));
	        const errorMessage =
	          errorData.detail || `Upload failed with status: ${res.status}`;
	        alert(`❌ ${file.name} upload failed: ${errorMessage}`);
	        continue;
	      }
	
	      const data = await res.json();
	      console.log("✅ Uploaded:", data);
	      alert(
	        `✅ Uploaded ${
	          data.pages || "content"
	        } from ${data.original_filename || file.name}`
	      );
	
	      await fetchFiles(clusterId); // refresh file list
	    } catch (err) {
	      console.error("Upload failed:", err);
	      alert("❌ Upload failed: " + err.message);
	    } finally {
	      setUploading(false);
	    }
	  }
	
	  e.target.value = null; // reset input
	};

    // 1) Ambil daftar chat untuk cluster aktif
    const fetchChats = useCallback(async (clusterId) => {
        const id = getClusterId(clusterId);
        if (!id) return;

        const ctrl = new AbortController();
        try {
            const url = `/api/chats?cluster_id=${encodeURIComponent(String(id))}`;
            const res = await fetch(url, {
            headers: getAuthHeaders(),
            signal: ctrl.signal,
            });
            if (!res.ok) throw new Error(`fetchChats ${res.status}`);
            const json = await res.json();
            setChatList(json.items || []);
        } catch (e) {
            if (e.name !== "AbortError") console.error("fetchChats error:", e);
        }
        return () => ctrl.abort();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // getAuthHeaders biasanya stable; jika tidak, bungkus jadi useMemo/useCallback.

    const fetchFiles = async () => {
        try {
            const headers = getAuthHeaders();

			const clusterId = getClusterId(activeCluster);
            if (!clusterId) {
                console.warn("⚠️ No active cluster selected.");
                setFiles([]);
                return;
            }

            const res = await fetch(`/api/list-files?cluster_id=${activeCluster}`, { headers });

            if (!res.ok) {
                console.error("Failed to fetch file list, status:", res.status);
                setFiles([]);
                return;
            }

            const data = await res.json();
            setFiles(data || []);
            console.log("Fetched files:", data.files);
        } catch (err) {
            console.error("Failed to fetch file list:", err);
            setFiles([]);
        }
    };

    const deleteFile = async (originalFilename) => {
        const confirmed = window.confirm(`Are you sure you want to delete ${originalFilename}?`);
        if (!confirmed) return;

        try {
            const res = await fetch(`/api/delete-file/${originalFilename}`, {
                method: "DELETE",
                headers: getAuthHeaders(),
            });

            if (!res.ok) {
                const errorData = await res.json();
                throw new Error(errorData.detail || `Failed to delete with status: ${res.status}`);
            }

            alert("✅ File deleted!");
            fetchFiles();
            if (currentPdfUrl && currentPdfUrl.includes(originalFilename)) {
                setCurrentPdfUrl(null);
                setNumPages(null);
                setPageNumber(1);
            }
        } catch (err) {
            console.error("❌ Failed to delete:", err);
            alert("Failed to delete file: " + err.message);
        }
    };

    const viewPdf = async (storedFilename, targetPage = 1) => {
        setShowImageViewer(false);
        setCurrentImageUrl(null);
        setPdfLoading(true);
        setPageNumber(targetPage);
        try {
            const res = await fetch(`/api/get-pdf/${storedFilename}`, {
                method: "GET",
                headers: getAuthHeaders(),
            });

            if (!res.ok) {
                const errorData = await res.json();
                throw new Error(errorData.detail || `Failed to fetch PDF with status: ${res.status}`);
            }

            const blob = await res.blob();
            const url = URL.createObjectURL(blob);
            setCurrentPdfUrl(url);
            openPdf(url);
        } catch (err) {
            console.error("❌ Failed to view PDF:", err);
            alert("Failed to load PDF: " + err.message);
            setCurrentPdfUrl(null);
        } finally {
            setPdfLoading(false);
        }
    };

    const viewImage = async (imageUrl) => {
        setPdfLoading(false);
        setShowPdfViewer(false);
        setCurrentPdfUrl(null);
        setImageLoading(true);
    
        // 🔒 Paksa URL menjadi HTTPS
        if (imageUrl.startsWith("http://")) {
            imageUrl = imageUrl.replace("http://", "https://");
        }
    
        try {
            const res = await fetch(imageUrl, {
                method: "GET",
                headers: getAuthHeaders(),
            });
    
            if (!res.ok) {
                const errorData = await res.json();
                throw new Error(errorData.detail || `Failed to fetch image with status: ${res.status}`);
            }
    
            const blob = await res.blob();
            const url = URL.createObjectURL(blob);
            setCurrentImageUrl(url);
            openImage(url);
        } catch (err) {
            console.error("❌ Failed to view image:", err);
            alert("Failed to load image: " + err.message);
            setCurrentImageUrl(null);
        } finally {
            setImageLoading(false);
        }
    };
    
    const handleReferenceClick = (originalFilename, page) => {
        const match = sources.find(
            s => s.filename === originalFilename && s.page === page
        );
        if (match) {
            viewPdf(match.stored_filename, page);
        } else {
            alert("🔍 File atau halaman tidak ditemukan.");
        }
    };

    useEffect(() => {
      const isMobile = window.innerWidth < 1024;
      if (isMobile) {
        setSidebarOpen(false);
      } else {
        setSidebarOpen(true); 
      }
    }, []);
    
	useEffect(() => {
	  const handleResize = () => {
	    setIsMobile(window.innerWidth < 768);
	  };
	
	  // cek pertama kali saat load
	  handleResize();
	
	  // dengarkan perubahan ukuran
	  window.addEventListener("resize", handleResize);
	  return () => window.removeEventListener("resize", handleResize);
	}, []);

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    useEffect(() => {
    if (isLoggedIn && activeCluster && token) {
        console.log("✅ Fetching files after login...");
        fetchFiles(); 
    }
    }, [isLoggedIn, activeCluster, token]);


    useEffect(() => {
        // reset panel saat cluster berganti
        setActiveChatPublicId(null);
        setMessages([]);

        const id = getClusterId(activeCluster);
        if (!id) {
            setChatList([]);
            return;
        }

        // load daftar chat untuk cluster aktif
        const cleanup = fetchChats(id);
        return () => {
            if (typeof cleanup === "function") cleanup();
        };
    }, [activeCluster, fetchChats]);

    useEffect(() => {
	    const storedToken = localStorage.getItem("authToken");
	    if (storedToken) {
	        setToken(storedToken);
	        setIsLoggedIn(true);
	    }
    }, []);

    useEffect(() => {
        localStorage.setItem("ui:sidebarOpen", String(sidebarOpen));
    }, [sidebarOpen]);

    useEffect(() => {
        if (rightPanelMode) localStorage.setItem("ui:rightPanelMode", rightPanelMode);
        else localStorage.removeItem("ui:rightPanelMode");
    }, [rightPanelMode]);

    useEffect(() => {
        setSelected(new Set());
    }, [activeCluster?.id]);

	useEffect(() => {
	  if (!isLoggedIn) return;
	  const saved = Number(localStorage.getItem("activeClusterId") || "");
	  const clusterId = saved || PERSONAL_CLUSTER_ID;
	  setCluster(clusterId);
	}, [isLoggedIn]); 

	useEffect(() => {
	  const handleResize = () => {
	    if (window.innerWidth >= 768) {
	      setMobileView("stocks");
	    }
	  };
	  window.addEventListener("resize", handleResize);
	  return () => window.removeEventListener("resize", handleResize);
	}, []);

	useEffect(() => {
	  localStorage.setItem("ui:sidebarOpen", String(sidebarOpen));
	}, [sidebarOpen]);
	
    useEffect(() => {
        scrollToBottom();
    }, [messages]);
	
	useEffect(() => {
	  const cid = localStorage.getItem("activeChatPublicId");
	  if (cid) setActiveChatPublicId(cid);
	}, []);
	
	useEffect(() => {
		if (!isAsk) return;

		const intent = askIntentRef.current; // "list" | "chat" | null

		if (intent === "list") {
			setAskMode("list");
			setMenuOpenIdMobile(null);
		} else if (intent === "chat") {
			setAskMode("chat");
		} else {
			// default kalau user akses /ask manual
			setAskMode("list");
		}

		// reset biar gak nyangkut
		askIntentRef.current = null;
	}, [isAsk]);

		

	// Chat Area for Mobile View
	const renderChatArea = () => (
	  <div
	    className={`${showPdfViewer} flex flex-col h-[100dvh] overflow-hidden [--bottom-nav:64px]`}
	  >		
	    {/* === AREA CHAT === */}
		<div className="flex-1 overflow-y-auto p-4 pb-[calc(var(--bottom-nav)+28px)] scrollbar-thin scrollbar-thumb-gray-600 scrollbar-track-transparent">
	      {!activeChatPublicId ? (
	        <div className="flex flex-col h-full items-center justify-center text-gray-400">
	          <p className="text-lg mb-2">👈 Silakan pilih atau buat chat dulu</p>
	          <p className="text-sm text-gray-500 text-center">
	            Klik tombol <strong>+ New</strong> atau pilih chat yang tersedia di sidebar kiri.
	          </p>
	        </div>
	      ) : (
	        <div className="space-y-2 bg-gray-800 p-4 rounded shadow-lg">
	          {messages.map((m, i) => (
	            <div
	              key={i}
	              className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}
	            >
	              <div
	                className={`p-3 rounded-xl max-w-[80%] mb-2 ${
	                  m.role === "user"
	                    ? "bg-blue-600 text-white self-end"
	                    : "bg-gray-700 text-gray-100 self-start"
	                }`}
	              >
	                <div className="text-xs font-semibold mb-1">
	                  {m.role === "user" ? "🙋 You" : "🤖 Bot"}
	                </div>
	                <div className="prose prose-invert text-sm break-words">
	                  <ReactMarkdown
	                    components={{
	                      a: ({ href, children }) => {
	                        const match = href?.match(/file=([^&]+)&page=(\d+)/);
	                        if (match) {
	                          const [_, filename, page] = match;
	                          return (
	                            <span
	                              onClick={() =>
	                                handleReferenceClick(
	                                  decodeURIComponent(filename),
	                                  parseInt(page)
	                                )
	                              }
	                              className="inline-block text-green-400 bg-gray-600/30 px-2 py-1 rounded hover:bg-gray-600 transition-all duration-150 cursor-pointer"
	                            >
	                              📎 {children}
	                            </span>
	                          );
	                        }
	                        return (
	                          <a
	                            href={href}
	                            target="_blank"
	                            rel="noopener noreferrer"
	                            className="text-blue-400 hover:underline"
	                          >
	                            {children}
	                          </a>
	                        );
	                      },
	                      p: ({ node, ...props }) => (
	                        <p {...props} className="mb-2 last:mb-0" />
	                      ),
	                    }}
	                  >
	                    {m.text}
	                  </ReactMarkdown>
	                </div>
	              </div>
	            </div>
	          ))}
	          {loading && (
	            <div className="text-green-400 italic animate-pulse">
	              <strong>Bot:</strong> Typing...
	            </div>
	          )}
	          <div ref={messagesEndRef} />
	        </div>
	      )}
	    </div>
	
		{/* === INPUT BAR === */}
		<div
		  className="sticky z-20 bg-gray-900 border-t border-gray-700 px-4 pt-3
		             pb-[calc(env(safe-area-inset-bottom)+12px)]"
		  style={{ bottom: "var(--bottom-nav)" }}
		>
			
		  <div className="flex gap-2">
		    <input
		      disabled={!activeChatPublicId}
		      type="text"
		      value={question}
		      onChange={(e) => setQuestion(e.target.value)}
		      onKeyDown={(e) => {
		        if (e.key === "Enter") ask();
		      }}
		      placeholder={
		        !activeChatPublicId
		          ? "👈 Silakan pilih atau buat chat dulu..."
		          : "Tulis pertanyaan di sini..."
		      }
		      className={`flex-1 min-w-0 p-3 rounded-lg border text-gray-200 placeholder-gray-500
		        ${
		          !activeChatPublicId
		            ? "bg-gray-900 cursor-not-allowed opacity-50"
		            : "bg-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500"
		        }
		      `}
		    />
		    <button
		      onClick={ask}
		      className="shrink-0 px-5 py-3 rounded-lg bg-blue-600 hover:bg-blue-700 text-sm font-medium transition duration-200"
		    >
		      Send
		    </button>
		  </div>
		</div>

	
		{/* Panel Files */}
		{showFilesPanel && (
			<div className="w-full mb-4 bg-gray-800 p-4 rounded-lg shadow-lg border border-gray-700 z-10">
				<div className="flex justify-between items-center mb-3">
					<h3 className="text-base text-gray-300 font-semibold">📂 Uploaded Files</h3>
					<button onClick={() => setShowFilesPanel(false)} className="text-gray-400 hover:text-white focus:outline-none">
						<svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
							<path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
						</svg>
					</button>
				</div>
		
				{/* Table File List */}
				<div className="overflow-x-auto max-h-64 overflow-y-auto custom-scrollbar">
					<table className="min-w-full text-sm text-gray-300 table-auto">
						<thead className="bg-gray-700 text-left">
							<tr>
								<th className="px-3 py-2">No</th>
								<th className="px-3 py-2">File</th>
								<th className="px-3 py-2">Actions</th>
							</tr>
						</thead>
						<tbody>
							{files.length === 0 ? (
								<tr>
									<td colSpan="3" className="text-center py-4 text-gray-500">No files found.</td>
								</tr>
							) : (
								files.map((file, index) => {
									const id = file.id;
									const checked = selected.has(id);
									return (
										<tr key={id} className="hover:bg-gray-700 border-b border-gray-600">
											<td className="px-3 py-2">{index + 1}</td>
											<td className="px-3 py-2 flex items-center">
												<input
													type="checkbox"
													id={`file-checkbox-${id}`}
													checked={checked}
													onChange={() => toggle(id)}
													className="form-checkbox h-4 w-4 text-blue-500 rounded border-gray-500 bg-gray-800 cursor-pointer mr-2"
												/>
												<label htmlFor={`file-checkbox-${id}`} className="truncate cursor-pointer">
													{file.filename}
												</label>
											</td>
											<td className="px-3 py-2 space-x-3">
												<button
													onClick={() => {
														if (file.file_type === 'pdf' && file.stored_filename) viewPdf(file.stored_filename);
														else if (file.file_type === 'image' && file.url) viewImage(file.url);
													}}
													disabled={!(file.file_type === 'pdf' && file.stored_filename) && !(file.file_type === 'image' && file.url)}
													className="text-blue-400 hover:underline disabled:opacity-50"
												>
													View
												</button>
												<button onClick={() => deleteFile(file.filename)} className="text-red-400 hover:underline">
													Delete
												</button>
											</td>
										</tr>
									);
								})
							)}
						</tbody>
					</table>
				</div>
		
				{/* Tombol Upload dan Indicator */}
				<label className="mt-4 bg-indigo-600 hover:bg-indigo-500 px-4 py-2 text-sm rounded-lg cursor-pointer font-medium block text-center">
				  <div className="flex items-center justify-center">
					<svg
					  xmlns="http://www.w3.org/2000/svg"
					  className="h-5 w-5 mr-2"
					  fill="none"
					  viewBox="0 0 24 24"
					  stroke="currentColor"
					>
					  <path
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth="2"
						d="M12 4v16m8-8H4"
					  />
					</svg>
					Add Files (PDF, Word, Excel, PPT, or Image)
				  </div>
				
				  <input
					type="file"
					multiple
					accept="
					  application/pdf,
					  application/vnd.openxmlformats-officedocument.wordprocessingml.document,
					  application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
					  application/vnd.openxmlformats-officedocument.presentationml.presentation,
					  image/png,
					  image/jpeg,
					  image/webp"
					onChange={handleFileUpload}
					className="hidden"
					disabled={uploading}
				  />
				</label>
				
				{uploading && (
				  <div className="flex items-center justify-center mt-2 text-yellow-400 text-sm animate-pulse">
					<svg
					  className="animate-spin h-5 w-5 mr-2"
					  xmlns="http://www.w3.org/2000/svg"
					  fill="none"
					  viewBox="0 0 24 24"
					>
					  <circle
						className="opacity-25"
						cx="12"
						cy="12"
						r="10"
						stroke="currentColor"
						strokeWidth="4"
					  />
					  <path
						className="opacity-75"
						fill="currentColor"
						d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
					  />
					</svg>
					Processing file...
				  </div>
				)}
			</div>
		)}
	  </div>
	);

	// apakah layar sedang mode mobile (< 768px)
	const [isMobile, setIsMobile] = useState(false);
	
	// halaman mana yang aktif di mobile: "stocks" atau "chat"
	const [mobileView, setMobileView] = useState("stocks");

	useEffect(() => {
	  const handleResize = () => {
	    setIsMobile(window.innerWidth < 768);
	  };
	
	  // cek pertama kali saat load
	  handleResize();
	
	  // perubahan ukuran
	  window.addEventListener("resize", handleResize);
	  return () => window.removeEventListener("resize", handleResize);
	}, []);

	const SAHAM_VISTA_CLUSTER_ID = 6;
	
	useEffect(() => {
	  if (!isLoggedIn) return;
	
	  // Admin bebas pilih cluster
	  if (userRole === "ADMIN") return;
	
	  // Paksa semua user non-admin selalu di Saham Vista
	  if (Number(activeCluster) !== SAHAM_VISTA_CLUSTER_ID) {
	    setActiveCluster(SAHAM_VISTA_CLUSTER_ID);
	
	    // kalau sistem kamu butuh trigger side-effect (load data per cluster)
	    // panggil handler yang biasa dipakai ClusterSelector:
	    if (typeof handleSelectCluster === "function") {
	      handleSelectCluster(SAHAM_VISTA_CLUSTER_ID);
	    }
	  }
	}, [isLoggedIn, userRole]); 

	useEffect(() => {
		if (!cid) return;
		openChat(cid); // openChat sekarang pakai public_id
	}, [cid]);	

	if (isStockDetail) {
		return (
			<div className="min-h-screen w-full bg-slate-950 text-gray-100">
				<StocksPanel />
			</div>
		);
	}


	return (
	  <div className="flex h-screen bg-gray-900 text-gray-200">
			{/* ========== MOBILE SIDEBAR: DRAWER OVERLAY ========== */}
			{sidebarOpen && (
			  <div className="fixed inset-0 z-40 flex md:hidden">
			    <div
			      className="flex-1 bg-black/50"
			      onClick={() => setSidebarOpen(false)}
			    />
			    <div className="w-4/5 max-w-xs bg-gray-900 border-r border-gray-800 h-full">
			      <Sidebar
			        onSystemMessageChange={setSystemMessage}
			        files={files}
			        selectedIds={selected}
			        onToggleFile={toggle}
			        onDeleteFile={deleteFile}
			        onUploadFile={handleFileUpload}
			        uploading={uploading}
			        onViewPdf={viewPdf}
			        onViewImage={viewImage}
			        activeCluster={activeCluster}
			        onClusterChange={setActiveCluster}
			        chatList={chatList}
			        activeChatPublicId={activeChatPublicId}
			        onNewChat={createNewChat}
			        onOpenChat={handleOpenChatFromSidebar}
			        onRenameChat={handleRenameChat}
			        onDeleteChat={handleDeleteChat}
			        rightPanelMode={rightPanelMode}
			        setRightPanelMode={setRightPanelMode}
			        setSidebarOpen={setSidebarOpen}
				    setShowUserRegistrationModal={setShowUserRegistrationModal}
  				    setShowUserProfileModal={setShowUserProfileModal}
  					setShowActivationCodeModal={setShowActivationCodeModal}
			      />
			    </div>
			  </div>
			)}
			
			{/* ========== DESKTOP SIDEBAR: STATIC COLUMN ========== */}
			<div
			  className={`hidden md:block bg-gray-900 border-r border-gray-800 h-full ${
			    sidebarOpen ? "w-64" : "w-0"
			  }`}
			>
			  {sidebarOpen && (
			    <Sidebar
			      onSystemMessageChange={setSystemMessage}
			      files={files}
			      selectedIds={selected}
			      onToggleFile={toggle}
			      onDeleteFile={deleteFile}
			      onUploadFile={handleFileUpload}
			      uploading={uploading}
			      onViewPdf={viewPdf}
			      onViewImage={viewImage}
			      activeCluster={activeCluster}
			      onClusterChange={setActiveCluster}
			      chatList={chatList}
			      activeChatPublicId={activeChatPublicId}
			      onNewChat={createNewChat}
			      onOpenChat={openChat}
			      onRenameChat={handleRenameChat}
			      onDeleteChat={handleDeleteChat}
			      rightPanelMode={rightPanelMode}
			      setRightPanelMode={setRightPanelMode}
			      setSidebarOpen={setSidebarOpen}
				  setShowUserRegistrationModal={setShowUserRegistrationModal}
  				  setShowUserProfileModal={setShowUserProfileModal}
  				  setShowActivationCodeModal={setShowActivationCodeModal}
			    />
			  )}
			</div>

	        {/* ✅ Konten utama */}
	    <div className="flex-1 flex flex-col">
	            {/* Header (fixed at top) */}
				<div className="sticky top-0 z-30 border-b border-gray-700 bg-gray-800/95 backdrop-blur shadow-md">
				  <div className="px-3 sm:px-4 h-14 flex items-center gap-3">
				
				    {/* LEFT: Toggle + Title */}
				    <div className="flex items-center gap-2 shrink-0">
				      <button
				        onClick={() => setSidebarOpen(!sidebarOpen)}
				        className="p-2 text-gray-400 hover:text-white"
				        title="Toggle Sidebar"
				      >
				        ☰
				      </button>
				      <h1 className="text-lg font-semibold text-purple-400 whitespace-nowrap">
				        Saham Vista
				      </h1>
				    </div>
				
				    {/* ✅ SEARCH: dekat title */}
				    <div className="w-[180px] sm:w-[260px] md:w-[360px] lg:w-[420px]">
				      <TickerSearchBox placeholder="Search kode saham..." />
				    </div>
				
				    {/* spacer */}
				    <div className="flex-1" />
				
				    {/* RIGHT: hidden controls (keep) + user menu */}
				    <div className="flex items-center gap-2">
				
				      {isLoggedIn && (
				        <>
				          {/* Cluster Selector (hidden for now) */}
				          <div className="hidden">
				            <ClusterSelector onSelectCluster={handleSelectCluster} />
				          </div>
				
				          {/* Engine Selector (hidden) */}
				          <div className="hidden">
				            <select
				              value={category}
				              onChange={(e) => setCategory(e.target.value)}
				              className="h-8 border border-gray-600 bg-gray-900 text-gray-200 rounded px-2 text-[12px]"
				              title="Engine"
				            >
				              {categories.map((c) => (
				                <option key={c.value} value={c.value}>
				                  {c.label}
				                </option>
				              ))}
				            </select>
				          </div>
				        </>
				      )}
				
				      {isLoggedIn ? (
				        <div className="relative">
				          <button
				            onClick={() => setShowProfileMenu(!showProfileMenu)}
				            className="w-9 h-9 rounded-full overflow-hidden border border-gray-600 hover:border-gray-500 focus:outline-none focus:ring-2 focus:ring-purple-500/40"
				            title="User Menu"
				          >
				            <img
				              src={`https://api.dicebear.com/6.x/initials/svg?seed=${userName || userEmail || "User"}`}
				              alt="User Avatar"
				              className="w-full h-full object-cover"
				            />
				          </button>
				
				          {showProfileMenu && (
				            <div className="absolute right-0 mt-2 w-56 bg-gray-800 rounded-lg shadow-xl z-50 border border-gray-700 overflow-hidden">
				              <div className="px-4 py-3 text-sm text-gray-300">
				                <div className="font-semibold truncate">{userName || userEmail}</div>
				                <div className="text-gray-400 text-xs">{userRole}</div>
				              </div>
				
				              <div className="h-px bg-gray-700" />

											<button
												onClick={() => {
													setShowProfileMenu(false);
													setShowUserProfileModal(true);
												}}
												className="w-full px-4 py-2 text-left text-sm text-gray-300 hover:bg-gray-700"
											>
												Profil Akun
											</button>

											<button
												onClick={() => {
													setShowProfileMenu(false);
													setShowActivationCodeModal(true);
												}}
												className="w-full px-4 py-2 text-left text-sm text-indigo-400 hover:bg-gray-700"
											>
												Activate Code
											</button>								  
				
				              {userRole === "admin" && (
				                <button
				                  onClick={() => {
				                    setShowProfileMenu(false);
				                    setShowUserRegistrationModal(true);
				                  }}
				                  className="w-full px-4 py-2 text-left text-sm text-blue-400 hover:bg-gray-700"
				                >
				                  Register User
				                </button>
				              )}
				
				              <div className="h-px bg-gray-700" />
				
				              <button
				                onClick={logout}
				                className="w-full px-4 py-2 text-left text-sm text-red-400 hover:bg-gray-700"
				              >
				                Logout
				              </button>
				            </div>
				          )}
				        </div>
				      ) : (
				        <button
				          onClick={triggerLoginPrompt}
				          className="px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded-lg text-sm font-medium transition duration-200"
				        >
				          Login
				        </button>
				      )}
				    </div>
				  </div>
				</div>
	
	            {/* Main Content Area */}
	      <div className="flex-1 flex overflow-hidden">
					{/* ================= DESKTOP (md+) ================= */}
					<div className="hidden md:flex flex-1 overflow-hidden">
						<PanelGroup 
							direction="horizontal"
							onLayout={handleLayout}
							defaultSizes={layout || (sidebarOpen ? [70, 30] : [100, 0])}
						>
							
							{/* Left Column: Chat and Chat Input */}
							<Panel minSize={35} defaultSize={rightPanelMode ? 33 : 100}>
								{renderChatArea()}
							</Panel>
		
							{/* Right Column: Viewer / Stocks */}
							{rightPanelMode && (
								<>
									<PanelResizeHandle className="w-1.5 bg-gray-700/60 hover:bg-blue-500 cursor-col-resize transition" />
									<Panel minSize={20} defaultSize={40}>
										<>
											<div
												ref={pdfContainerRef}
												className="relative flex flex-col h-full w-full overflow-hidden bg-gray-900 rounded-lg"
											>
												{/* Close button */}
												<button
													onClick={closeRightPanel}
													className="absolute top-2 right-2 text-gray-300 hover:text-red-400 p-1 rounded transition"
													title="Close Panel"
												>
													<svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
														<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
													</svg>
												</button>
			
												{/* ===== PDF Viewer ===== */}
												{rightPanelMode === "pdf" && currentPdfUrl && (
													<>
															<Document
															  file={currentPdfUrl}
															  onLoadSuccess={(e) => { setNumPages(e.numPages); setPdfLoading(false); }}
															  onLoadError={(error) => { console.error('Error loading PDF:', error); alert('Failed to load PDF document.'); setPdfLoading(false); }}
															  className="flex flex-col items-center overflow-y-auto h-full pb-20"
															>
															<Page
																pageNumber={pageNumber}
																renderTextLayer={true}
																renderAnnotationLayer={true}
																width={pdfContainerRef.current ? pdfContainerRef.current.offsetWidth - 32 : 600}
															/>
														</Document>
														<div className="flex items-center justify-center mt-4 bg-gray-700 p-2 rounded-lg">
															<button
																disabled={pageNumber <= 1}
																onClick={() => setPageNumber(p => Math.max(1, p - 1))}
																className="px-3 py-1 rounded-lg bg-blue-600 hover:bg-blue-700 text-sm font-medium transition disabled:opacity-50 mr-2"
															>
																Prev
															</button>
															<p className="text-gray-200 text-sm">
																Page {pageNumber || (numPages ? 1 : '--')} of {numPages || '--'}
															</p>
															<button
																disabled={!!numPages && pageNumber >= numPages}
																onClick={() => setPageNumber(p => (numPages ? Math.min(numPages, p + 1) : p + 1))}
																className="px-3 py-1 rounded-lg bg-blue-600 hover:bg-blue-700 text-sm font-medium transition disabled:opacity-50 ml-2"
															>
																Next
															</button>
														</div>
													</>
												)}
			
												{/* ===== Image Viewer ===== */}
												{rightPanelMode === "image" && currentImageUrl && (
													<img src={currentImageUrl} alt="Chart" className="max-w-full max-h-full object-contain" />
												)}
			
												{/* ===== Stocks Table ===== */}
												{rightPanelMode === "stocks" && (
													<div className="w-full h-full overflow-hidden bg-gray-900 rounded-lg">
														<StocksPanel 
															onAskAi={handleAskAiFromStocks}
													    	category={category}
													        setCategory={setCategory}
													        groupBy={groupBy}
													        setGroupBy={setGroupBy}
															categories={categories}
															openAskChat={openAskChat}																
														/>
													</div>
												)}

												{/* ===== Accuracy Panel (Admin only UI sudah di Sidebar) ===== */}
												{rightPanelMode === "accuracy" && (
													<div className="w-full h-full overflow-hidden bg-gray-900 rounded-lg">
														<AccuracyPanel />
													</div>
												)}

												{/* ===== Portfolio Panel ===== */}
												{rightPanelMode === "portfolio" && (
												  <div className="w-full h-full overflow-y-auto bg-gray-900 rounded-lg p-2">
												    <PortfolioPage />
												  </div>
												)}

												{/* ===== Watchlist Panel ===== */}
												{rightPanelMode === "watchlist" && (
												  <div className="w-full h-full overflow-y-auto bg-gray-900 rounded-lg p-2">
												    <WatchlistPage />
												  </div>
												)}

											</div>
										</>
									</Panel>
								</>
							)}
						</PanelGroup>
					</div>

					{/* ================= MOBILE (< md) ================= */}
					<div className="flex-1 md:hidden pb-24 relative">

					{/* === STOCKPICKS === Halaman Default */}

					{/* === WATCHLIST === */}
					{isWatchlist && <WatchlistPage />}

					{/* === SEARCH === */}
					{isSearch && <SearchPage />}

					{/* === PORTFOLIO === */}
					{isPortfolio && <PortfolioPage />}

					{/* === ASK AI (CHAT LIST / CHAT AREA) === */}
					{isAsk && (
					<div className="flex flex-col h-[calc(100vh-3rem)] bg-gray-900">

						{/* ===== Header ===== */}
						<div className="sticky top-0 z-20 flex items-center justify-between gap-2 px-3 py-2 border-b border-gray-700 bg-gray-900">
							{askMode === "chat" ? (
								<button
								onClick={() => {
									setAskMode("list");
									setMenuOpenIdMobile(null);
								}}
								className="px-3 py-1 rounded bg-gray-800 text-xs text-gray-200 hover:bg-gray-700"
								>
								← Back
								</button>
							) : (
								<div className="w-[72px]" /> // spacer biar title center
							)}

							<span className="text-sm font-semibold text-gray-100">
								{askMode === "chat" ? "Chat" : "📝 Chat Lists"}
							</span>

						</div>

						{/* ===== Body ===== */}
						<div className="flex-1 overflow-y-auto pb-24">

						{/* ===== MODE: LIST ===== */}
						{askMode === "list" && (
						  <ul className="mt-3 list-none space-y-2 px-3 text-sm">
						    {(chatList || []).length === 0 ? (
						      <li className="text-xs text-gray-500 italic">No chats yet.</li>
						    ) : (
						      (chatList || []).map((c) => {
						        const pid = String(c.public_id || "").trim(); // ✅ pakai public_id
						        const isActive = String(activeChatPublicId || "").trim() === pid;
						
						        return (
						          <li
						            key={pid || c.id} // ✅ key ideal: public_id
						            className={`bg-gray-800 rounded-lg p-3 text-white ${
						              isActive ? "ring-1 ring-indigo-500" : "hover:bg-gray-700"
						            }`}
						          >
						            <div className="flex justify-between items-center gap-2">
						              <button
						                onClick={() => {
						                  // ✅ selalu open pakai public_id
						                  if (typeof handleOpenChatFromSidebar === "function") {
						                    handleOpenChatFromSidebar(pid);
						                  } else if (typeof openChat === "function") {
						                    openChat(pid);
						                  }
						                  setMenuOpenIdMobile(null);
						                  setAskMode("chat");
						                }}
						                className="truncate text-left flex-1"
						                title={c.title}
						              >
						                {c.title}
						              </button>
						
						              <button
						                onClick={(e) => {
						                  e.stopPropagation();
						                  setMenuOpenIdMobile(menuOpenIdMobile === pid ? null : pid);
						                }}
						                className="text-gray-300 hover:text-white px-2"
						                aria-label="Menu"
						              >
						                •••
						              </button>
						            </div>
						
						            {menuOpenIdMobile === pid && (
						              <div className="mt-3 pl-1 flex gap-4 text-sm text-blue-300">
						                <button
						                  onClick={() => {
						                    handleRenameChat?.(pid);
						                    setMenuOpenIdMobile(null);
						                  }}
						                  className="hover:underline"
						                >
						                  ✏️ Rename
						                </button>
						                <button
						                  onClick={() => {
						                    handleDeleteChat?.(pid);
						                    setMenuOpenIdMobile(null);
						                  }}
						                  className="hover:underline text-red-400"
						                >
						                  🗑️ Delete
						                </button>
						              </div>
						            )}
						          </li>
						        );
						      })
						    )}
						  </ul>
						)}


						{/* ===== MODE: CHAT ===== */}
						{askMode === "chat" && (
							<div className="h-full">
							{/* render chat full screen */}
							{renderChatArea()}
							</div>
						)}
						</div>

					</div>
					)}


					{/* === DEFAULT / HOME (STOCKS) === */}
					{!isWatchlist && !isSearch && !isAsk && !isPortfolio && (
						<div className="h-[calc(100vh-3rem)] overflow-hidden bg-gray-900">
						<StocksPanel
							onAskAi={handleAskAiFromStocks}
							openAskChat={openAskChat}
							category={category}
							setCategory={setCategory}
							groupBy={groupBy}
							setGroupBy={setGroupBy}
							categories={categories}
						/>
						</div>
					)}

					<BottomNav onAskList={openAskList} />

					</div>
							
	            </div>
	        </div>

			{/* User Profile Modal */}
			<UserProfileModal
				isOpen={showUserProfileModal}
				onClose={() => setShowUserProfileModal(false)}
			/>

			{/* Activation Code Modal */}
			<ActivationCodeModal
			  isOpen={showActivationCodeModal}
			  onClose={() => setShowActivationCodeModal(false)}
			  onActivated={(data) => {
			    console.log("Activation success:", data);
			  }}
			/>

			{/* User Registration Form Modal */}
	        {showUserRegistrationModal && (
	            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
	                <UserRegistrationForm onClose={() => setShowUserRegistrationModal(false)} />
	            </div>
	        )}
	    </div>
	);
}

export default function App() {
    return (
        <Router>
            <AuthProvider>
                <Routes>
                    {/* ===== PUBLIC PAGES ===== */}
                    <Route path="/privacy" element={<PrivacyPage />} />
                    <Route path="/terms" element={<TermsPage />} />

                    {/* ===== APP (SEMUA TAB MOBILE) ===== */}
                    <Route
                        path="/"
                        element={
                            <RequireLogin>
                                <MainApplication />
                            </RequireLogin>
                        }
                    />

                    <Route
                        path="/stockpicks"
                        element={
                            <RequireLogin>
                                <MainApplication />
                            </RequireLogin>
                        }
                    />

                    <Route
                        path="/watchlist"
                        element={
                            <RequireLogin>
                                <MainApplication />
                            </RequireLogin>
                        }
                    />

                    <Route
                        path="/search"
                        element={
                            <RequireLogin>
                                <MainApplication />
                            </RequireLogin>
                        }
                    />

                    <Route
                        path="/ask"
                        element={
                            <RequireLogin>
                                <MainApplication />
                            </RequireLogin>
                        }
                    />

                    <Route
                        path="/portfolio"
                        element={
                            <RequireLogin>
                                <MainApplication />
                            </RequireLogin>
                        }
                    />

					<Route
						path="/stocks/:code"
						element={
							<RequireLogin>
								<StockDetailPage />
							</RequireLogin>
						}
					/>

					<Route
						path="/ask/c/:cid"
						element={
							<RequireLogin>
								<MainApplication />
							</RequireLogin>
						}
					/>

                    {/* ===== SAFETY FALLBACK (ANTI BLANK) ===== */}
                    <Route
                        path="*"
                        element={
                            <RequireLogin>
                                <MainApplication />
                            </RequireLogin>
                        }
                    />
                </Routes>
            </AuthProvider>
        </Router>
    );
}
